<template>
  <div @contextmenu.prevent.stop>
    <div class="cover" :style="{'width':pageWidth,'height':pageHeight}" @click="hideMenu"></div>
    <div class="container" :style="{'top':menuY+'px','left':menuX+'px'}">
      <div class="munucell borderNone" @click="edit">编辑</div>
      <div class="munucell" @click="remove">删除</div>
    </div>
  </div>
</template>

<script>

//话术右键菜单
export default {
  props:['menuY','menuX','menuData'],
  data () {
    return {
      pageHeight:document.documentElement.clientHeight+'px',
      pageWidth:document.documentElement.clientWidth+'px',
    }
  },
  components:{
    
  },
  computed:{
    
  },
  methods:{
    edit(){
      this.$emit('edit');
      this.hideMenu();
    },
    remove(){
      this.$emit('remove');
      this.hideMenu();
    },
    hideMenu(){
      this.$emit('hideMenu')
    }
  },
  async mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover{
  position: fixed;
  left: 0;
  top: 0;
  z-index:9999;
}

.container{
  width: 96px;
  background-color: #F0F0F0;
  border:1px solid #E5E5E5;
  position: absolute;
  z-index:99999;
  border-radius: 8px;
}

.munucell{
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #E5E5E5;
  color: #3C3C3C;
}

.borderNone{
  border: none;
}
</style>
